import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-add-municipality',
  templateUrl: './add-municipality.component.html',
  styleUrls: ['./add-municipality.component.css']
})
export class AddMunicipalityComponent implements OnInit {
	districtsData:any[];
  response:string;
  status:boolean;

  constructor(private dataService : DataService) { }

  municipalityData: FormGroup = new FormGroup({
   	municipality: new FormControl('', [Validators.required]),
    district: new FormControl('',[Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.districts()
		.subscribe((districts:any) => {
  			this.districtsData = districts.districts;
  	})
  }

  submitMunicipalityData(data:any){
  	this.dataService.submitMunicipality(data)
  		.subscribe((response:any)=>{
  			this.response = response.message;
        this.status = response.status;
  		})
  }

}
